export default {
  BAndRText: "Books & Reviews",
  Srchbook: "Search by book",
  offlisugg: "Ofellio's suggestions ",
  recentlyRated: "Recently rated",

  // Reveiw Page
  rewbtn1: "Want to read",
  rewbtn2: "Write a review",
  rewbtn3: "Use for Book Duo",
  rateBook: "Rate this book",
  buyon: "Buy on",
  Read: "Read",
  reviewtext: "Review",
  ratingtext: "Your rating",
  readon: "Read on",
  book: "Book",
  ebook: "E-book",
  audiobook: "Audiobook",
  revTitle: "Review's title",
  submitbtn: "Submit",

  // Book Duo Page
  yourbd: "Your Book Duo",
  serchbook: "Search book",
  DidText: "Did not find your book? Enter details!",
  city: "City",
  type: "Type",
  lookigfr: "Looking for",
  male: "Male",
  female: "Female",
  idk: "I don't care",
  agerg: "Age range",
  language: "Language",
  detil: "Details ",
  optnal: "Optional",
  lookiginsp: "Looking for inspiration",
  suggbokduo: "Suggested book for a Book Duo",
  seemoresugg: "See more suggestions",
  bokcvr: "Book's cover ",
  title: "Title",
  writer: "Writer ",
  genre: "Genre ",
  upload: "Upload ",
  add: "Add ",
  online: "On-line",
  onlink: "Add link to the video call (Teams, Zoom, Google Meet etc)",
  noBookSelected: "No book selected",
  loading: "Loading...",
  noResultsFound: "No results found",
  meetingLink: "Meeting Link",
  noLimit: "No Limit",
  languageTooltip: "This is the language participants will speak during Book Duo.",
  languageTooltipBookClub: "This is the language participants will speak during Book Club.",
  updating: "Updating...",
  publishing: "Publishing...",
  update: "Update",
  noBooksFound: "No books found under this Suggested books for a 1:1.",
  wellDone: "Well done!",
  bookDuoLive: "Your Book Duo is now live.",
  willInformInterest: "We will inform you when someone shows interest!",
  seeOn: "See on",
  map: "Map",

  // Book Club Page
  when: "When",
  time: "Time ",
  age: "Age",
  publsbtn: "Publish ",
  day: "Day",
  month: "Month",
  year: "Year",
  hour: "Hour",
  min: "Min",
  max: "Max",
  selectTime: "Select time",
  selectLanguage: "Select Language",
  selectType: "Select Type",
  inPerson: "In-person",
  attendees: "Attendees",
  eventDetails: "Event details",

  // Silent Reading Page
  where: "Where",
  venue: "Venue",
  address: "Address",

  // BookAnd Review page Event
  welc: "Welcome",
  memb: "Member",
  exploreText: "Explore and join the available events and create your own.",
  sbybooks: "Book ",
  month: "Month ",
  sortby: "Sort by",
  cbduo: "Create Book Duo",
  smoreevent: "See more events",
  dowant: "Do you want to create your own event?",
  ledAmbsdr: "Book Clubs and Silent Readings are led by Ambassadors.",
  bAnAmbsdor: "Become an Ambassador  ",
  leadText: "to lead one or explore and join",
  evtnear: "events available near you.",
  BookDuoFirstText: `Are you looking for a personal connection? A Book Duo is perfect for you!`,
  BookDuoSecondText: `Looking for a personal connection? Choose a book, select a partner's age and gender preference, and start a one-to-one literary journey.`,

  BookClubFirstText: `Discover book clubs in-person in your area or on-line, hosted in a snug setting such as cafes, bars or a welcoming venue or via video conference.`,
  BookClubSecondText: `Join welcoming in-person or online book clubs hosted in cozy settings. Each group is facilitated by an Ambassador to ensure a lively and inclusive experience.`,

  BookSilentFirstText: `Held in a relaxing andcomfortable setting, SilentReadings offer a peaceful escapefor up to 10 readers.`,
  BookSilentSecondText: `Enjoy peaceful silent reading sessions. Bring your own book, relax, and share the quiet joy of reading together.`,

  DuoBtnText: `Create Book Duo`,
  ClubBtnText: `Create Book Club`,
  SilentBtnText: `Create Silent Reading`,
  bookDuoTitle: "Book Duo",
  bookClubTitle: "Book Club",
  bookSilentTitle: "Silent reading",

  // BOOK_CLUB DUO SILENTREADING
  yownbook: "Your own book",
  resetFilters: "Reset Filters",
  resetAll: "Reset All",
  applyFilters: "Apply Filters",
  filters: "Filters",
  full: "FULL",
  booked: "Booked",
  open: "Open",
  buyon: "Buy on",
  gender: "Gender",
  locatedin: "Located in",
  aboutbook: `About the book`,
  readmore: `Read More `,
  readless: `Read less `,
  details: "Details",
  totalspot: "Total spots",
  spotleft: "Spots left",
  join: "Join",
  share: "Share",
  cregistration: "Complete your registration",
  registrationmsg: "Your e-mail address will be shared with the Ambassador ",
  welldone: "Well done!",
  attending: "You are attending ",
  attendmsg:
    "You can now see this event in your Ofellio's dashboard and chat with your Ambassador",
  thankyou: "Thank you!",
  thankmsg:
    "The organizer is now aware of your interest and may send you a message to arrange the detals of this Book Duo",
  // CHAT PAGE
  msgtext: "Messages ",
  vprofile: "Dashboard",
  mute: "Mute",
  block: "Block",
  unblock: "Unblock",
  report: "Report",
  cancelR: "Cancel",

  // Setting Page
  pprofile: "Personal Profile",
  accnotifi: "Account Notification",
  uploadp: "Upload photo",
  name: "Name",
  surname: "Surname",
  dob: "Date of Birth",
  aboutme: "About me",
  country: "Country",
  favgenre: "Favorite Genres",
  asmedia: "Add your social media below",
  savechgbtn: "Save changes",

  cypass: "Change your password",
  cypasstext:
    "When you change your passowrd you will be automatically signed out from your other sessions",
  cpass: "Change password",
  cyemail: "Change your e-mail",
  cyemailtext:
    "When you change your passowrd you will be automatically signed out from your other sessions",
  cemail: "Change e-mail",
  notifi: "Notificaion ",
  emailmeab: "Email me about",
  lastesttext: "Latest trending books",
  upcomtext: "Upcoming month's new books",
  baevent: "Books, Authors and events I would enjoy ",
  newoff: "New Ofellio features",
leadin:"I'm leading",
  curnpass: "Current Password",
  newpass: "New Password",
  cnewpass: "Confirm New Password",
  curnemail: "Current e-mail",
  newemail: "New e-mail",
  cnewemail: "Confirm New e-mail",
  delyacc: "Delete your account ",
  sorrytext: "We are very sorry you want to leave us!",
  suretext: "Are you sure you want to do this? ",
  decitext:
    "If you decide to use Ofellio again, you will need to create a new account.",
  pass: "Password",

  // meun
  jan: "January",
  feb: "Febuary",
  mar: "March",
  apr: "April",
  may: "May",
  jun: "June",
  jul: "July",
  aug: "August",
  sep: "September",
  oct: "October",
  nov: "November",
  dec: "December",
  // Month abbreviations
  monthAbbrJan: "Jan",
  monthAbbrFeb: "Feb",
  monthAbbrMar: "Mar",
  monthAbbrApr: "Apr",
  monthAbbrMay: "May",
  monthAbbrJun: "Jun",
  monthAbbrJul: "Jul",
  monthAbbrAug: "Aug",
  monthAbbrSep: "Sep",
  monthAbbrOct: "Oct",
  monthAbbrNov: "Nov",
  monthAbbrDec: "Dec",
  cri: "Crime",
  fic: "Fiction",
  grpnvl: "Graphic Novels & Manga",
  yng: "Young Adults & LGBTQ+",
  nonfic: "Non-Fiction",
  scifan: "Sci-Fi & Fantasy",
  others: "Others",
  morerec: "Most recent",
  lessrec: "Least recent ",

  // HeaderProfil
  setg: "Settings ",
  logout: "Logout",

  // dashbords pages
  editprf: "Edit Profile",
  cbduo: "Create Book Duo",
  joining: "I am joining",
  bandrew: "Books & Reviews ",

  upcomclub: "Upcoming Book Clubs",
  upcomduo: "Upcoming Book Duos",
  upcomsil: "Upcoming Silent Readings",
  allpst: "All past events ",
  edit: "Edit",
  canc: "Cancel RSVP",
  going: "going",
  ngoing: "not going ",
  cancel: "Cancel",

  level: "Level",
  cbclub: "Create Book Club",
  cbsil: "Create Silent Reading ",
  loyprog: "Loyalty Programme",
  mang: "Manage",
  attlist: "Attendees list",
  event: "Cancel RSVP",

  chatgroup: "Chat with the group",
  chatambas: "Chat with Ambassador",

  bookshelv: "Sally's Bookshelves",
  reviews: "Reviews",

  // Leading Page
  ambassador: "Ambassador",
  member: "Member",
  level1: "Level 1",
  level2: "Level 2",
  level3: "Level 3",
  level4: "Level 4",
  toLevel: "to",
  highestLevel: "🎉 You've reached the highest level!",
  editProfile: "Edit Profile",
  createBookClub: "Create Book Club",
  createSilentReading: "Create Silent Reading",
  createBookDuo: "Create Book Duo",
  createEvent: "+ Create Event",
  attendeesList: "Attendees list",
  edit: "Edit",
  cancel: "Cancel",
  wantToRead: "Want to Read",
  read: "Read",
  remove: "Remove",
  tbd: "TBD",
  full: "FULL",
  yourOwnBook: "Your own book",
  ageLabel: "Age:",
  manage: "Manage",
  cancelRSVP: "Cancel RSVP",
  imLeading: "I'm Leading",
  imJoining: "I'm Joining",
  booksAndReviews: "Books & Reviews",
  loyaltyProgram: "Loyalty Program",
  upcomingBookClubs: "Upcoming Book Clubs",
  upcomingSilentReadings: "Upcoming Silent Readings",
  upcomingBookDuos: "Upcoming Book Duos",
  noEventsToShow: "No events to be shown.",
  wantToReadLower: "Want to read",
  readLower: "Read",
  reviewsLower: "Reviews",
  noRatedBooks: "You Haven't rated any books yet.",
  giftsDiscounts: "Gifts and discounts on reading",
  loyaltyDescription: "The more you read, the more you win! Enjoy discounts and perks as you level up.",
  starterReader: "Starter Reader",
  starterReaderDesc: "Begin your journey as an Ofellio Ambassador and start leading your first reading experiences.",
  starterReaderReward: "Early recognition and access to future Ambassador perks.",
  communityBuilder: "Community Builder",
  communityBuilderDesc: "Keep connecting readers and creating engaging book events within your community.",
  communityBuilderReward: "Priority access to new features and exclusive updates.",
  proHost: "Pro Host",
  proHostDesc: "You're shaping meaningful reading moments and inspiring others through your events.",
  proHostReward: "Invitations to upcoming Ofellio initiatives and special surprises.",
  legend: "Legend",
  legendDesc: "Continue inspiring readers worldwide — your leadership shapes the Ofellio community.",
  legendReward: "Unlock exclusive recognition and evolving benefits.",
  attendees: "Attendees",
  noAttendeesYet: "No attendees yet.",
  // Modal translations for add book manually
  booksCover: "Book's Cover",
  writerLabel: "Writer",
  genreLabel: "Genre",
  aboutTheBookLabel: "About the book",
  addButton: "Add",
  chatWithGroup: "Chat with the group",
  cancelEvent: "Cancel Event",
  cancelRSVPConfirm: "Are you sure you want to cancel your RSVP?",
  cancelEventConfirm: "Are you sure you want to cancel this event?",
  cancelRSVPEmail: "A cancellation e-mail will be sent to Ambassador.",
  cancelEventEmail: "A cancellation e-mail will be sent to the current attendees.",

  // How It Works Section
  howOfellioWorks: "How Ofellio works",
  howItWorksDesc: "Discover new ways to connect through books — whether one-on-one, in a group, or in peaceful silent reading sessions.",
  bookDuoTitle: "Book Duo",
  bookDuoDesc: "Looking for a personal connection? Choose a book, select a partner's age and gender preference, and start a one-to-one literary journey.",
  bookClubTitle: "Book Club",
  bookClubDesc: "Join welcoming in-person or online book clubs hosted in cozy settings. Each group is facilitated by an Ambassador to ensure a lively and inclusive experience.",
  silentReadingTitle: "Silent reading",
  silentReadingDesc: "Enjoy peaceful silent reading sessions. Bring your own book, relax, and share the quiet joy of reading together.",
  exploreThe: "Explore the",
  existingEvents: "existing events",
  or: "or",
  createYourOwn: "create your own",
  joinOfellio: "Join Ofellio",
  signUp: "Sign up",
  chooseYourCountry: "Choose your country",
  joined: "joined",
  joinedCapitalized: "Joined",
  shareThisEvent: "Share this event",
  linkVisibleAttendees: "Link visible to attendees only",
  recentReviews: "Recent reviews",
  noReviewsAvailable: "No Reviews Available",
  writeAReview: "Write a review",
  yourRating: "Your rating",
  update: "Update",
  aboutTheBook: "About the book",
  makeAChoiceForThisBook: "Make a choice for this book",
  howDidYouReadIt: "How did you read it?",
  noRating: "No rating",
  reviewPublished: "Review published",
  useForBookDuo: "Use for Book Duo",
  yourReview: "Your review",
  addAShortTitle: "Add a short title",
  shareYourThoughts: "Share your thoughts about this book...",
  send: "Send",
  bookclubLive: "Well done! Your Bookclub is now live and people can join it.",
  silentReadingLive: "Well done! Your Silent Reading is now live and people can join it.",
  dashboard: "Dashboard",
  
  // Day abbreviations
  dayMon: "Mon",
  dayTue: "Tue",
  dayWed: "Wed",
  dayThu: "Thu",
  dayFri: "Fri",
  daySat: "Sat",
  daySun: "Sun",
  
  // Additional translations
  ambassadorLabel: "Ambassador:",
  createdBy: "Created BY:",
  youAreAttendingThis: "You are attending this",
  youCanNowSeeThisEvent: "You can now see this event in your Ofellio's dashboard and chat",
  withYourAmbassador: "with your Ambassador",
  chatWithAmbassador: "Chat with Ambassador",
  yourRequestHasBeenSent: "Your request has been sent to the ambassador",
  sentYouAMessage: "sent you a message!",
  justJoinedYour: "just joined your",
  bookClubsAndSilentReadings: "Book Clubs and Silent Readings are led by Ambassadors.",
  becomeAnAmbassador: "Become an Ambassador",
  toLeadOneOrExplore: "to lead one or explore and join",
  eventsAvailable: "events available.",
};